"use strict";

var ConnectionStatus = {
  Uninitialized: 0,
  Connecting: 1,
  Online: 2,
  ExpiredToken: 3,
  FailedToConnect: 4,
  Ended: 5
};

module.exports = ConnectionStatus;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ambit-ai/ambit-client/lib/ConnectionStatus.js
// module id = 363
// module chunks = 0